import { Component, OnInit } from '@angular/core';
import { OrganizationConfig } from '../../../../../models/organization-config';
import { AccountService } from '../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-linking-accounts-config',
  templateUrl: './linking-accounts-config.component.html',
  styleUrls: ['./linking-accounts-config.component.css']
})
export class LinkingAccountsConfigComponent implements OnInit {

  public orgConfig: OrganizationConfig;

  public loadingOrgConfig = false;
  public savingOrgConfig = false;

  public successMessage = '';
  public errorMessage = '';
  public errors: any = {};

  public serverError: number = null;

  public get parentChildRelationAllowed(): boolean {
    return this.orgConfig.parent_relation_allowed || this.orgConfig.child_relation_allowed;
  }
  public set parentChildRelationAllowed(value: boolean) {
    this.orgConfig.parent_relation_allowed = value;
    this.orgConfig.child_relation_allowed = value;
  }

  public get legalGuardianWardRelationAllowed(): boolean {
    return this.orgConfig.legal_guardian_relation_allowed || this.orgConfig.legal_ward_relation_allowed;
  }
  public set legalGuardianWardRelationAllowed(value: boolean) {
    this.orgConfig.legal_guardian_relation_allowed = value;
    this.orgConfig.legal_ward_relation_allowed = value;
  }

  public get guardianWardRelationAllowed(): boolean {
    return this.orgConfig.guardian_relation_allowed || this.orgConfig.ward_relation_allowed;
  }
  public set guardianWardRelationAllowed(value: boolean) {
    this.orgConfig.guardian_relation_allowed = value;
    this.orgConfig.ward_relation_allowed = value;
  }

  constructor(
    private accountService: AccountService,
    private orgConfigService: OrganizationConfigService
  ) { }

  ngOnInit() {
    this.loadOrganizationConfig();
  }

  /**
   * Load the organization config from the API.
   *
   * We do not use the local-stored copy, in order to avoid pop-in of changed
   * values.
   */
  public loadOrganizationConfig() {
    this.loadingOrgConfig = true;

    this.orgConfigService
      .loadOrganizationConfig()
      .then(() => {
        this.orgConfig = this.orgConfigService.getOrganizationConfig();
        this.loadingOrgConfig = false;
      });
  }

  /**
   * Save the updated organization config to the API.
   */
  public saveOrganizationConfig() {
    this.savingOrgConfig = true;
    this.successMessage = '';

    this.errors = {};
    this.errorMessage = '';

    this.orgConfigService
      .updateAccountLinkingConfig(this.orgConfig)
      .then(updatedOrgConf => {
        this.orgConfig = updatedOrgConf;
        this.successMessage = 'Linking configuration updated successfully.';
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to modify the linking configuration.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.savingOrgConfig = false; });
  }

}
